import { ENV, StaticTokenListResolutionStrategy } from "@solana/spl-token-registry";

const NETWORKS = {
  "mainnet-beta": ENV.MainnetBeta,
  testnet: ENV.Testnet,
  devnet: ENV.Devnet,
};

export const tokenDetailsRegistry = async (mintAddress, network = "mainnet-beta") => {
  //const tokenList = await new TokenListProvider().resolve();
  //const tokens = tokenList.getList();
  const tokens = new StaticTokenListResolutionStrategy().resolve();

  const chainId = NETWORKS[network] || NETWORKS["mainnet-beta"];

  const tokenInfo = tokens.find(
    (token) => token.address === mintAddress && token.chainId === chainId
  );

  return tokenInfo
    ? {
        name: tokenInfo.name,
        symbol: tokenInfo.symbol,
        decimals: tokenInfo.decimals,
        logo: tokenInfo.logoURI,
      }
    : null;
};
